module.exports = "<div class=\"dropdown-wrapper\" (mouseleave)=\"onFocusLost()\" >\r\n  <div class=\"selected-membership\" (click)=\"toggleOptions()\"[innerHTML]=\"selected?.name\"></div>\r\n  <div class=\"arrow-down\"></div>\r\n  <div data-simplebar class=\"options\" *ngIf=\"showOptions || showOTDropdown || showPSDropdown\">\r\n    <p *ngFor=\"let value of values\" (click)=\"selectOption(value)\" [innerHTML]=\"value.name\"></p>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/NightKey/CMS/nightkey-cms/src/app/shared/dropdown/dropdown.component.html
// module id = ../../../../../src/app/shared/dropdown/dropdown.component.html
// module chunks = main